import * as React from "react";
import Dialog from "@mui/material/Dialog";

export enum DialogPosition {
	Top = "top",
	Center = "center",
	Bottom = "bottom",
	Left = "left",
}
export interface SimpleDialogProps {
	open: boolean;
	onClose?: () => void;
	children?: React.ReactNode;
	position?: DialogPosition;
	className?: string;
	style?: React.CSSProperties;
}

const positionStyles = {
	[DialogPosition.Top]: {
		sx: {
			position: "absolute",
			top: 30,
			margin: 0,
		},
	},
	[DialogPosition.Center]: {
		sx: {
			position: "absolute",
			top: "50%",
			left: "50%",
			transform: "translate(-50%, -50%)",
			margin: 0,
			maxWidth: 1000,
		},
	},
	[DialogPosition.Bottom]: {
		sx: {
			position: "absolute",
			bottom: 30,
			margin: 0,
		},
	},
	[DialogPosition.Left]: {
		sx: {
			position: "absolute",
			top: "50%",
			left: 30,
			transform: "translate(0, -50%)",
			margin: 0,
		},
		className: "left-dialog",
	},
};

export default function SimpleDialog(props: SimpleDialogProps) {
	const { onClose = () => {}, open, children, position = DialogPosition.Center, className = "" } = props;

	return (
		<Dialog
			onClose={onClose}
			open={open}
			PaperProps={positionStyles[position]}
			slotProps={{
				backdrop:
					position === DialogPosition.Top || position === DialogPosition.Left
						? { sx: { backgroundColor: "transparent" } }
						: undefined,
			}}
		>
			<div className={"p-4 " + className} style={{ minWidth: 350, ...props.style }}>
				{children}
			</div>
		</Dialog>
	);
}
